export const _en = {
    uid: {
        label: "Code"
    },
    name: {
        label: "Name"
    },
    color: {
        label: "Color"
    }
};

export const _fr = {
    uid: {
        label: "Sigle"
    },
    name: {
        label: "Nom"
    },
    color: {
        label: "Couleur"
    }
};